export function blogUrl(publicUrl: string, userName: string) {
  return `${publicUrl}/${userName}`
}

export function rssBlogUrl(publicUrl: string, userName: string) {
  return `${publicUrl}/${userName}/rss.xml`
}

export function extractUserNameFromBlogUrl(
  url: string,
  publicUrl: string,
): string | null {
  try {
    const parsedUrl = new URL(url)
    const expectedBase = new URL(publicUrl)

    if (parsedUrl.origin !== expectedBase.origin) {
      return null
    }

    const pathMatch = parsedUrl.pathname.match(/^\/([^/]+)\/rss\.xml$/)
    if (!pathMatch || !pathMatch[1]) {
      return null
    }

    return pathMatch[1]
  } catch {
    return null
  }
}
